import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ProjectItem from './project_item';
import {ProjectApi} from "../../customer_project/api/project-api";

const welcomeMessageKey = 'MBR-PROJECTS-WELCOME-MESSAGE';
const timeRequestedKey = 'MBR-PROJECTS-ADDITIONAL-TIME-REQUESTED';

export default function CustomerProjectsList({ projects, userName, proPlatform, showAddMoreTimeMessage }) {
  const saveWelcomeMessageState = () => localStorage.setItem(welcomeMessageKey, 'done');
  const shouldShowWelcomeMessage = () => localStorage.getItem(welcomeMessageKey) !== 'done';
  const [projectsList] = useState(projects);
  const [showWelcomeMessage, setShowWelcomeMessage] = useState(shouldShowWelcomeMessage());

  const saveTimeRequestedState = () => localStorage.setItem(timeRequestedKey, new Date().toLocaleDateString('en-GB'));
  const timeRequestedSaved = () => localStorage.getItem(timeRequestedKey) == new Date().toLocaleDateString('en-GB');
  const [timeRequested, setTimeRequested] = useState(showAddMoreTimeMessage && timeRequestedSaved());

  const closeWelcomeMessage = () => {
    saveWelcomeMessageState();
    setShowWelcomeMessage(state => false);
  };

  function requestMoreTimeOnClick() {
    ProjectApi.requestAdditionalTime(
      response => {
        setTimeout(() => {
          saveTimeRequestedState();
          setTimeRequested(true);
        }, 500);
        return response;
      },
      response => {
        alert('Sorry. Something went wrong.');
        return response;
      },
    );
  }

  // function anyArchivedProjects() {
  //   console.log(showAddMoreTimeMessage);
  //   const arcvhivedProjects = projectsList.filter(project => {
  //     return project.plan !== "consultancy" && project.status == "archived"
  //   });
  //   return arcvhivedProjects.length > 0;
  // }

  function renderAddMoreTimeMessage() {
    if (proPlatform) {
      return;
    };

    return (
        <div
          className={cn('internal-page -wide customer-projects-welcome_wrapper -complete-project')}
        >
          <div className="customer-projects-welcome">
            <h2>
              Hi &nbsp;{userName},
            </h2>
            <p>
              Your time with your designer may have wrapped up, but this is just the start of the next exciting phase in your journey!
            </p><p>
            As you move forward, you'll have access to <b>exclusive discounts</b> (only available through us) and <b>unlimited shopping support</b> to help bring your design to life.
            </p><p>
              I'm here to assist with everything - from project scheduling to managing samples and deliveries - whatever you need, for as long as it takes.
            </p><p>
              If you'd like to chat or have any questions, simply drop me a note in the CHAT or click the button below to schedule a call.
            </p><p>
              <a className="btn btn-reversed -y2025 -case-as-is -longer" href="http://meetings.hubspot.com/jessica-alice" target="_blank" rel="noopener">Book a call with Jess </a>
            </p><p>
              I can't wait to continue working with you!
            </p><p>
              Jess x
            </p>
          </div>
        </div>
      )
  };

  return (
    <div className="container">
      {!proPlatform && !showAddMoreTimeMessage && (
        <div
          className={cn('internal-page -wide customer-projects-welcome_wrapper', {
            '-closed': !showWelcomeMessage,
          })}
        >
          <div className="customer-projects-welcome">
            <button
              className="customer-projects-welcome_close"
              onClick={() => closeWelcomeMessage()}
            />
            <h2>
              Hey&nbsp;
              {userName}, your design journey starts here! ✨
            </h2>
            <p> You’ve just landed in your very own design dashboard - the hub where all the magic happens!</p>
            <p>
              Here’s where you can keep tabs on your project’s progress, chat with your designer, check out your furniture credits and partner benefits (yep, we love to treat you!).
            </p>
            <p>
              The design journey usually takes up to 3 weeks. So, to get the most out of the experience, make sure to check in regularly and stay connected with your designer.
            </p>
            <p>
              We’re thrilled to have you with us and can’t wait to bring your dream space to life. Let’s do this! 💪
            </p>
            <p> Team My Bespoke Room x</p>
          </div>
        </div>
      )}
      {showAddMoreTimeMessage && renderAddMoreTimeMessage()}

      <div className="customer-projects-list internal-page -wide">
        <div className='heading'>
          <h1 className="internal-page_header title" title="My designs" id="my-projects" />
        </div>
        {projects.length === 0 && (
          <div className="customer-projects-list_item -nothing-found">You have no designs yet.</div>
        )}
        {projectsList.map(project => (
          <ProjectItem project={project} proPlatform={proPlatform} key={project.id} />
        ))}
      </div>
    </div>
  );
}

CustomerProjectsList.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape([])).isRequired,
  userName: PropTypes.string.isRequired,
  proPlatform: PropTypes.bool,
  showAddMoreTimeMessage: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/components/customer_projects_list/index.js